/**
 * Orígenes de solicitudes/requerimientos
 */
export const ORIGENES = [
  'Portal del Propietario',
  'Acta de Entrega',
  'Observación de Entrega',
  'Sperant',
  'Portal de Negocios'
];

export const ORIGENES_QUE_NO_CALCULAN_GARANTIA = [
  'Observación de Entrega',
  'Acta de Entrega'
];

export const debeCalcularGarantia = (origen) => {
  return !ORIGENES_QUE_NO_CALCULAN_GARANTIA.includes(origen);
};
